var OCS = OCS || {};
OCS.UI = OCS.UI || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.EmbeddableImage = new Class({
    Extends: OCS.WxBriefing.Classes.Panel,
    Implements: Options,
    class_name: 'EmbeddableImage',
    options: {
        container: null,
        template: 'image_embed',
        map_class_selector: '.map',
        reload_rate: 60000
    },
    render: function () {
        this.populate_panel();
        //this.frame_changed(null, new Date().getTime());
    },
    populate_panel: function () {
        this.parent();
        this.add_image();
        this.load_panel_options();
    },
    add_image: function () {
        OCS.DynamicScriptLoader.load({
            load: ['/scripts/classes/product_base.js', '/scripts/classes/image.js', '/scripts/classes/image_wbp.js'],
            onComplete: function () {
                // Set the html of the container with the new data that came in
                var url = $.trim(OCS.WxBriefing.Live.UI.replace_url_template_text(this.get_product_content()));
                
                var image_embed_ops = {
                    map_container: this.options.map_class_selector,
                    src: url,
                    image_container_id: "image_embed_" + this.create_unique_id(),
                    refresh_time: this.options.reload_rate
                };
                var tm = OCS.WxBriefing.Functions.get_template_manager();
                var content = Elements.from(tm.get_html(this.options.template, image_embed_ops));
                content.inject(this.options.container);
                if (OCS.Product) {
                    this.set_viewer(new OCS.Product.WeatherBriefingImage(this.options.container.getElement('img'), image_embed_ops));
                    this.viewer.resize();
                }
                this.options.container.removeClass('empty');
            }.bind(this)
        }).catch(function (reason) {
            console.debug(reason);
        });
    },
    destroy: function () {
        if (this.viewer) {
            this.viewer.destroy();
        }
        this.parent();
    },
    resize: function () {
        this.parent();
        if (this.viewer) {
            this.viewer.resize();
        }
    }
});